import Icon from './Icon';
import { NAV, canSee } from './nav';

// Sidebar — ported 1-to-1 from the frozen mockup (v0.7): Work / Administration / Oversight
// sections, monoline icon + label, gold-rail active state (`.nav-item.active`).
function Group({ title, items, view, role, onNavigate }) {
  const visible = items.filter((i) => canSee(i.id, role));
  if (!visible.length) return null;
  return (
    <>
      <div className="nav-section">{title}</div>
      {visible.map((i) => (
        <button
          key={i.id}
          type="button"
          className={`nav-item ${view === i.id ? 'active' : ''}`}
          onClick={() => onNavigate(i.id)}
        >
          <Icon name={i.ic} size={18} />
          {i.label}
        </button>
      ))}
    </>
  );
}

export default function Sidebar({ view, role, onNavigate }) {
  return (
    <nav className="sidebar">
      <Group title="Work" items={NAV.work} view={view} role={role} onNavigate={onNavigate} />
      <Group title="Administration" items={NAV.admin} view={view} role={role} onNavigate={onNavigate} />
      <Group title="Oversight" items={NAV.oversight} view={view} role={role} onNavigate={onNavigate} />
    </nav>
  );
}
